import useLocationService from "hooks/useLocationService";
import { useSession } from "hooks/useSession";
import React, { useState, useEffect } from "react";
import { fetchWrapper } from "utils/apiFetch";
import { showMainToast } from "utils/showToast";
import { captureAvdm } from "utils/rdService";
import { AEPSReceiptModa } from "Settings/Reports/AEPSReceipt";

function AEPSServicePage() {
  const [showModal, setShowModal] = useState(false);
  const [showMSModal, setShowMSModal] = useState(false);
  const [receiptData, setReceiptData] = useState(null);
  const [pidData, setpidData] = useState("");
   const {
      location,
  
      permission,
      getLocation,
      checkPermission,
    } = useLocationService(true);
  const { userid } = useSession();
  const [bankList, setBankList] = useState([]);
  const [selectedBank, setSelectedBank] = useState("");

  const [activeTab, setActiveTab] = useState("details-tab-pane");
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    mobile: "",
    aadhar: "",
    amount: "",
    selectedDevice: "MANTRA",
  });

  /* NEW STATES */
  const [loadingOverlay, setLoadingOverlay] = useState(false);
  const [buttonsDisabled, setButtonsDisabled] = useState(false);
  const [consentGiven, setConsentGiven] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  /* CAPTURE FINGERPRINT */
  const handleCapture = async () => {
    if (buttonsDisabled) return;
    const response = await captureAvdm(formData.selectedDevice, "");
    if (response.success) setpidData(response.data);
    else alert("Error: " + response.error);
  };

  /* TAB SWITCH */
  const handleTabSwitch = (tabId) => {
    setActiveTab(tabId);
    if (tabId === "payment-tab-pane" || tabId === "mini-statement-tab-pane") {
      setFormData((prev) => ({ ...prev, amount: "0" }));
    }
    setButtonsDisabled(false);
  };

  /* INIT */
  useEffect(() => {

    const fetchBankList = async () => {
      try {
        const res = await fetchWrapper("https://api.mokshiq.in/aeps_bank_list_1");
        const data = res;
        if (data?.data) setBankList(data.data);
      } catch (err) { }
    };
    fetchBankList();
  }, []);

  /* INPUTS */
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));

    setButtonsDisabled(false);
    setSubmitting(false);
  };

  const handleAadharChange = (e) => {
    const rawValue = e.target.value.replace(/\D/g, "");
    let formatted = rawValue;
    if (rawValue.length > 4) formatted = rawValue.replace(/(\d{4})(?=\d)/g, "$1-");
    if (rawValue.length <= 12)
      setFormData((prev) => ({ ...prev, aadhar: formatted }));

    if (errors.aadhar) setErrors((prev) => ({ ...prev, aadhar: "" }));

    setButtonsDisabled(false);
    setSubmitting(false);
  };

  /* VALIDATION */
  const validateForm = () => {
    const newErrors = {};

    if (!formData.mobile) newErrors.mobile = "Mobile number is required";
    else if (!/^[6-9]\d{9}$/.test(formData.mobile))
      newErrors.mobile = "Enter valid 10-digit mobile";

    const aad = formData.aadhar.replace(/\D/g, "");
    if (!aad) newErrors.aadhar = "Aadhaar is required";
    else if (aad.length !== 12) newErrors.aadhar = "Invalid Aadhaar number";

    if (
      activeTab === "details-tab-pane" ||
      activeTab === "personal-tab-pane"
    ) {
      const amt = Number(formData.amount);
      if (!amt) newErrors.amount = "Amount is required";
      else if (amt < 100) newErrors.amount = "Amount must be at least ₹100";
      else if (amt > 10000)
        newErrors.amount = "Amount cannot exceed ₹10,000";
    }

    if (!selectedBank) newErrors.selectedFingerprint = "Please select a bank";
    if (!formData.selectedDevice)
      newErrors.selectedDevice = "Please select a device";

    if (!pidData) newErrors.pid = "Please scan fingerprint first";

    if (!consentGiven) newErrors.consentGiven = "Consent is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleView = async (refid, tranType = "", miniStatementFromAPI = []) => {
    if (!refid || refid === "" || refid === "null" || refid === "undefined") {
      console.warn("No refid found. Receipt will not open.");
      return;
    }

    try {
      const url = `https://api.mokshiq.in/show_receipt_aeps?id=${refid}`;
      const response = await fetchWrapper(url);

      if (!response || !response.data) {
        console.error("No receipt data for refid:", refid);
        return;
      }

      let finalData = response.data;

      // ✅ If MS, use ministatement from MAIN API call (NOT from receipt)
      if (tranType?.toUpperCase() === "MS") {
        finalData = {
          ...response.data,
          ministatement: miniStatementFromAPI || []
        };
      }


      setReceiptData(finalData);
      setShowModal(true);

    } catch (err) {
      console.error("Receipt fetch error:", err);
    }
  };




  /* SUBMIT */
  const handleSubmit = async () => {
    if (submitting) return;
    if (!validateForm()) return;

    setSubmitting(true);
    setLoadingOverlay(true);

    const formPayload = new FormData();
    formPayload.append("userid", userid);
    formPayload.append("transection_platform", "WEB");

    let transectionType = "CW";
    if (activeTab === "personal-tab-pane") transectionType = "CD";
    else if (activeTab === "payment-tab-pane") transectionType = "BE";
    else if (activeTab === "mini-statement-tab-pane") transectionType = "MS";

    formPayload.append("transection_type", transectionType);
    formPayload.append("lat", location.lat);
    formPayload.append("long", location.lng);
    formPayload.append("finger_code", pidData);
    formPayload.append("number", formData.mobile);
    formPayload.append("aadhar", formData.aadhar.replace(/-/g, ""));
    formPayload.append(
      "amount",
      transectionType === "BE" || transectionType === "MS"
        ? "0"
        : formData.amount
    );
    formPayload.append("bankname", selectedBank);
    formPayload.append("finger_device", formData.selectedDevice);
    formPayload.append(
      "device_id",
      Math.floor(100000 + Math.random() * 900000).toString()
    );

    try {
      const res = await fetchWrapper("https://api.mokshiq.in/aeps_initiate", {
        method: "POST",
        body: formPayload,
      });

      if (res.status) {
        handleView(res.refid, transectionType, res.data.ministatement || []);

        showMainToast(res.data.message || "Transaction Successful", "success");
        setpidData("");
        formData.append("mobile", "");
        setSubmitting(false);
        setLoadingOverlay(false);
      } else {

        handleView(res.refid, transectionType, res.data.ministatement || []);
        showMainToast(res.data.message || "Transaction Failed", "danger");
        setpidData("");

        setButtonsDisabled(true);

        setTimeout(() => {
          setButtonsDisabled(false);
          setSubmitting(false);
        }, 300);

        setTimeout(() => setLoadingOverlay(false), 600);
      }
    } catch (err) {
      showMainToast("Network error", "danger");
      setpidData("");

      setButtonsDisabled(true);

      setTimeout(() => {
        setButtonsDisabled(false);
        setSubmitting(false);
      }, 300);

      setTimeout(() => setLoadingOverlay(false), 600);
    }
  };

  const isAmountDisabled =
    activeTab === "payment-tab-pane" || activeTab === "mini-statement-tab-pane";

  const currentAmount = isAmountDisabled ? "0" : formData.amount;

  return (
    <main>
      {/* ✅ LOADING OVERLAY */}
      {loadingOverlay && (
        <div
          className="page-loader-overlay d-flex justify-content-center align-items-center"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255,255,255,0.7)",
            zIndex: 3000,
          }}
        >
          <div className="spinner-border text-primary" role="status"></div>
        </div>
      )}

      <div className="col-12">
        <div className="block-card-list">
          <div className="card">
            <div className="card-header">
              <h5>AEPS Dashboard</h5>
            </div>

            <div className="card-body">
              {/* ---------------- TABS ---------------- */}
              <div className="nav business-nav d-flex">
                <button
                  className={`btn nav-link flex-grow-1 ${activeTab === "details-tab-pane" ? "active" : ""
                    }`}
                  onClick={() => handleTabSwitch("details-tab-pane")}
                  disabled={buttonsDisabled}
                >
                  <i className="ph-duotone ph-user-circle-plus"></i>
                  <span className="f-s-18 f-w-500">Cash Withdrawl</span>
                </button>

                <button
                  className={`btn nav-link flex-grow-1 ${activeTab === "personal-tab-pane" ? "active" : ""
                    }`}
                  onClick={() => handleTabSwitch("personal-tab-pane")}
                  disabled={buttonsDisabled}
                >
                  <i className="ph-duotone ph-user-switch"></i>
                  <span className="f-s-18 f-w-500">Cash Deposit</span>
                </button>

                <button
                  className={`btn nav-link flex-grow-1 ${activeTab === "payment-tab-pane" ? "active" : ""
                    }`}
                  onClick={() => handleTabSwitch("payment-tab-pane")}
                  disabled={buttonsDisabled}
                >
                  <i className="ph-duotone ph-credit-card"></i>
                  <span className="f-s-18 f-w-500">Balance Enquiry</span>
                </button>

                <button
                  className={`btn nav-link flex-grow-1 ${activeTab === "mini-statement-tab-pane" ? "active" : ""
                    }`}
                  onClick={() => handleTabSwitch("mini-statement-tab-pane")}
                  disabled={buttonsDisabled}
                >
                  <i className="ph-duotone ph-credit-card"></i>
                  <span className="f-s-18 f-w-500">Mini Statement</span>
                </button>
              </div>

              {/* ---------------- FORM ---------------- */}
              <div className="tab-content mt-3">
                <div className="tab-pane fade show active">
                  <div className="app-form">
                    {/* MOBILE / AADHAAR / AMOUNT */}
                    <div className="row">
                      <div className="col-4">
                        <div className="mb-1">
                          <label className="form-label">Customer Mobile</label>
                          <input
                            className={`form-control ${errors.mobile ? "is-invalid" : ""
                              }`}
                            type="text"
                            name="mobile"
                            value={formData.mobile}
                            onChange={handleInputChange}
                            disabled={buttonsDisabled}
                            maxLength="10"
                          />
                          {errors.mobile && (
                            <div className="invalid-feedback">
                              {errors.mobile}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-4">
                        <div className="mb-1">
                          <label className="form-label">Aadhar Number</label>
                          <input
                            className={`form-control ${errors.aadhar
                                ? "is-invalid"
                                : formData.aadhar.replace(/\D/g, "")
                                  .length === 12
                                  ? "is-valid"
                                  : ""
                              }`}
                            type="text"
                            name="aadhar"
                            value={formData.aadhar}
                            onChange={handleAadharChange}
                            disabled={buttonsDisabled}
                            maxLength="19"
                          />
                          {errors.aadhar && (
                            <div className="invalid-feedback">
                              {errors.aadhar}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-4">
                        <div className="mb-1">
                          <label className="form-label">Amount</label>
                          <input
                            className={`form-control ${errors.amount ? "is-invalid" : ""
                              }`}
                            type="number"
                            name="amount"
                            value={currentAmount}
                            onChange={handleInputChange}
                            disabled={isAmountDisabled || buttonsDisabled}
                            min="1"
                            max="10000"
                          />
                          {errors.amount && (
                            <div className="invalid-feedback">
                              {errors.amount}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* ---------------- BANK SELECTION ---------------- */}
                    <div className="row">
                      <div className="col-md-12">
                        <div className="card">
                          <div className="card-body">
                            {errors.selectedFingerprint && (
                              <div className="text-danger mb-2">
                                {errors.selectedFingerprint}
                              </div>
                            )}

                            <div className="row">
                              {/* FIXED RADIO BUTTONS */}
                              <div className="col-sm-6 col-xl-2">
                                <label className="form-checkimage">
                                  <input
                                    className="checkimage-input"
                                    type="radio"
                                    value="607027"
                                    checked={selectedBank === "607027"}
                                    onChange={(e) => {
                                      setSelectedBank(e.target.value);
                                      setButtonsDisabled(false);
                                    }}
                                    disabled={buttonsDisabled}
                                  />
                                  <span className="check-box radiobox">
                                    <img
                                      alt=""
                                      className="checkbox-image w-100"
                                      src="../assets/images/service/punjab.jpg"
                                    />
                                  </span>
                                </label>
                              </div>

                              <div className="col-sm-6 col-xl-2">
                                <label className="form-checkimage">
                                  <input
                                    className="checkimage-input"
                                    type="radio"
                                    value="607094"
                                    checked={selectedBank === "607094"}
                                    onChange={(e) => {
                                      setSelectedBank(e.target.value);
                                      setButtonsDisabled(false);
                                    }}
                                    disabled={buttonsDisabled}
                                  />
                                  <span className="check-box radiobox">
                                    <img
                                      alt=""
                                      className="checkbox-image w-100"
                                      src="../assets/images/service/sbi.jpg"
                                    />
                                  </span>
                                </label>
                              </div>

                              <div className="col-sm-6 col-xl-2">
                                <label className="form-checkimage">
                                  <input
                                    className="checkimage-input"
                                    type="radio"
                                    value="990309"
                                    checked={selectedBank === "990309"}
                                    onChange={(e) => {
                                      setSelectedBank(e.target.value);
                                      setButtonsDisabled(false);
                                    }}
                                    disabled={buttonsDisabled}
                                  />
                                  <span className="check-box radiobox">
                                    <img
                                      alt=""
                                      className="checkbox-image w-100"
                                      src="../assets/images/service/kotak.png"
                                    />
                                  </span>
                                </label>
                              </div>

                              <div className="col-sm-6 col-xl-2">
                                <label className="form-checkimage">
                                  <input
                                    className="checkimage-input"
                                    type="radio"
                                    value="606985"
                                    checked={selectedBank === "606985"}
                                    onChange={(e) => {
                                      setSelectedBank(e.target.value);
                                      setButtonsDisabled(false);
                                    }}
                                    disabled={buttonsDisabled}
                                  />
                                  <span className="check-box radiobox">
                                    <img
                                      alt=""
                                      className="checkbox-image w-100"
                                      src="../assets/images/service/baroda.png"
                                    />
                                  </span>
                                </label>
                              </div>

                              <div className="col-md-6 col-xl-4">
                                <div className="mt-4">
                                  <label className="form-label">
                                    Select Other Bank
                                  </label>
                                  <select
                                    className="form-select"
                                    value={selectedBank}
                                    onChange={(e) => {
                                      setSelectedBank(e.target.value);
                                      setButtonsDisabled(false);
                                    }}
                                    disabled={buttonsDisabled}
                                  >
                                    <option value="">Select Bank</option>
                                    {bankList.map((bank) => (
                                      <option
                                        key={bank.id}
                                        value={bank.iinno}
                                      >
                                        {bank.bankName}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* ---------------- DEVICE ---------------- */}
                    <div className="col-md-6 col-xl-12">
                      <div className="card equal-card">
                        <div className="card-body">
                          {errors.selectedDevice && (
                            <div className="text-danger mb-2">
                              {errors.selectedDevice}
                            </div>
                          )}

                          <div className="form-selectgroup">
                            <div className="row g-3">
                              {/* MANTRA */}
                              <div className="col-sm-6 col-lg-3">
                                <div className="select-item">
                                  <input
                                    className="form-check-input"
                                    id="MANTRA"
                                    type="radio"
                                    value="MANTRA"
                                    checked={formData.selectedDevice === "MANTRA"}
                                    onChange={(e) => {
                                      setFormData((prev) => ({
                                        ...prev,
                                        selectedDevice: e.target.value,
                                      }));
                                      setButtonsDisabled(false);
                                    }}
                                    disabled={buttonsDisabled}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="MANTRA"
                                  >
                                    <span className="d-flex align-items-center">
                                      <img
                                        alt=""
                                        className="w-30 h-30"
                                        src="../assets/images/service/mantra.png"
                                      />
                                      <span className="ms-2">
                                        <span className="fs-6">MANTRA</span>
                                        <span className="d-block text-secondary">
                                          Select Mantra
                                        </span>
                                      </span>
                                    </span>
                                  </label>
                                </div>
                              </div>

                              {/* MORPHO */}
                              <div className="col-sm-6 col-lg-3">
                                <div className="select-item">
                                  <input
                                    className="form-check-input"
                                    id="MORPHO"
                                    type="radio"
                                    value="MORPHO"
                                    checked={formData.selectedDevice === "MORPHO"}
                                    onChange={(e) => {
                                      setFormData((prev) => ({
                                        ...prev,
                                        selectedDevice: e.target.value,
                                      }));
                                      setButtonsDisabled(false);
                                    }}
                                    disabled={buttonsDisabled}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="MORPHO"
                                  >
                                    <span className="d-flex align-items-center">
                                      <img
                                        alt=""
                                        className="w-30 h-30"
                                        src="../assets/images/service/morpho.jpeg"
                                      />
                                      <span className="ms-2">
                                        <span className="fs-6">MORPHO</span>
                                        <span className="d-block text-secondary">
                                          Select Morpho
                                        </span>
                                      </span>
                                    </span>
                                  </label>
                                </div>
                              </div>

                              {/* STARTEK */}
                              <div className="col-sm-6 col-lg-3">
                                <div className="select-item">
                                  <input
                                    className="form-check-input"
                                    id="STARTEK"
                                    type="radio"
                                    value="STARTEK"
                                    checked={formData.selectedDevice === "STARTEK"}
                                    onChange={(e) => {
                                      setFormData((prev) => ({
                                        ...prev,
                                        selectedDevice: e.target.value,
                                      }));
                                      setButtonsDisabled(false);
                                    }}
                                    disabled={buttonsDisabled}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="STARTEK"
                                  >
                                    <span className="d-flex align-items-center">
                                      <img
                                        alt=""
                                        className="w-30 h-30"
                                        src="../assets/images/service/startek.jpg"
                                      />
                                      <span className="ms-2">
                                        <span className="fs-6">STARTEK</span>
                                        <span className="d-block text-secondary">
                                          Select Startek
                                        </span>
                                      </span>
                                    </span>
                                  </label>
                                </div>
                              </div>

                              {/* EVOLUTE */}
                              <div className="col-sm-6 col-lg-3">
                                <div className="select-item">
                                  <input
                                    className="form-check-input"
                                    id="EVOLUTE"
                                    type="radio"
                                    value="EVOLUTE"
                                    checked={formData.selectedDevice === "EVOLUTE"}
                                    onChange={(e) => {
                                      setFormData((prev) => ({
                                        ...prev,
                                        selectedDevice: e.target.value,
                                      }));
                                      setButtonsDisabled(false);
                                    }}
                                    disabled={buttonsDisabled}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="EVOLUTE"
                                  >
                                    <span className="d-flex align-items-center">
                                      <img
                                        alt=""
                                        className="w-30 h-30"
                                        src="../assets/images/service/evolute.jpg"
                                      />
                                      <span className="ms-2">
                                        <span className="fs-6">EVOLUTE</span>
                                        <span className="d-block text-secondary">
                                          Select Evolute
                                        </span>
                                      </span>
                                    </span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* CONSENT */}
                    <div className="form-check mt-3">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="consentGiven"
                        checked={consentGiven}
                        onChange={(e) => {
                          setConsentGiven(e.target.checked);
                          setButtonsDisabled(false);
                        }}
                        disabled={buttonsDisabled}
                      />
                      <label
                        className="form-check-label text-success"
                        htmlFor="consentGiven"
                      >
                        I hereby provide my consent to CSP to use my Aadhaar number/
                        VID to complete AEPS transaction authorisation.
                      </label>
                    </div>

                    {errors.pid && (
                      <div className="text-danger mt-2">{errors.pid}</div>
                    )}
                    {errors.consentGiven && (
                      <div className="text-danger mt-2">
                        {errors.consentGiven}
                      </div>
                    )}

                    {/* ---------------- SCAN + SUBMIT ---------------- */}
                    <div className="col-md-6 col-xl-12 mt-4">
                      <div className="d-flex justify-content-center align-items-center gap-3 flex-wrap">
                        {/* SCAN */}
                        <button
                          onClick={handleCapture}
                          className="btn btn-outline-primary p-0"
                          style={{ width: "80px", height: "80px" }}
                          type="button"
                          disabled={buttonsDisabled}
                        >
                          <img
                            src="../assets/images/service/scan.gif"
                            alt="Gif Button"
                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                          />
                        </button>

                        {/* SUBMIT */}
                        <div className="col-md-6 col-lg-4 col-12 mt-2">
                          <div className="d-grid gap-2">
                            <button
                              className="btn btn-primary w-100"
                              type="button"
                              disabled={buttonsDisabled}
                              onClick={handleSubmit}
                            >
                              {activeTab === "details-tab-pane" && "Withdraw Cash"}
                              {activeTab === "personal-tab-pane" && "Deposit Cash"}
                              {activeTab === "payment-tab-pane" && "Check Balance"}
                              {activeTab === "mini-statement-tab-pane" &&
                                "Get Mini Statement"}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* END */}
                  </div>
                </div>
              </div>
            </div>

            {/* CARD END */}
          </div>
        </div>
      </div>
      <AEPSReceiptModa
        receiptData={receiptData}
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        title="AEPS Receipt"
        logoUrl={"assets/images/logo/2.png"} // You can pass your logo URL here
      />

    </main>
  );
}

export default AEPSServicePage;
